import type { CheckoutAlertMessage as GQLItem } from '../generated/checkout.graphql';
import { take } from '../util';

export type CheckoutAlert = {
  title?: string;
  messages?: string[];
};

export const fromGql = (gqlItem: GQLItem): CheckoutAlert =>
  take(gqlItem, 'title', 'messages') as CheckoutAlert;
